import { DialogContent, Stack } from "@mui/material";
import {
  BottomSheet,
  Illustration,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

import { DialogFooter } from "../../components/DialogFooter";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { InHomeVisitCardSkeleton } from "../Card/Skeleton";
import { type VisitWithCaseData } from "../types";
import { InHomeVisitBookingCard } from "./Card";

interface VisitBookedBottomSheetProps {
  modalState: UseModalState;
  visit: VisitWithCaseData;
  isLoading: boolean;
}

export function VisitBookedBottomSheet(props: VisitBookedBottomSheetProps) {
  const { modalState, isLoading, visit } = props;
  const { patient, case: caseData, workplaceName } = useInHomeVisitModalsDataContext();
  const specialties = caseData?.attributes.specialties ?? [];

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        />
      }
    >
      <DialogContent sx={{ backgroundColor: "unset", py: 8, mt: 8 }}>
        <Stack direction="column" alignItems="center" spacing={9}>
          <Illustration type="shift-booked" />
          <Title variant="h2" component="h2" sx={{ textAlign: "center", textWrap: "balance" }}>
            Your visit is booked!
          </Title>
          {!isLoading && (
            <InHomeVisitBookingCard
              visit={visit}
              patient={patient}
              specialties={specialties}
              workplaceName={workplaceName}
            />
          )}
          {isLoading && <InHomeVisitCardSkeleton loadingLabel="Loading visit details" />}
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
